import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {NotificationService} from '@services/notification.service';

@Component({
  selector: 'si-notification-box-icon',
  templateUrl: './notification-box-icon.component.html',
  styleUrls: ['./notification-box-icon.component.scss']
})
export class NotificationBoxIconComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  hasNotificationPending: boolean;

  constructor(private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.notificationService.resetNotificationPending();
    this.subscriptions.push(
      this.notificationService.getNotificationPendingObservable().subscribe(hasNotificationPending => {
        this.hasNotificationPending = hasNotificationPending;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
